import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CaseCreateWizardService } from './case-create-wizard.service';
import { MessagingService } from '../../services/messaging.service';
import { Globals } from '../../globals';
import {MessagingConstants} from '../../models/MessagingConstants';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {MatStepper} from '@angular/material/stepper';
import {CaseProcedureFormConfigurationModel} from '../../models/caseProcedures/case-procedure-form-configuration.model';
import {ToothPickerComponent} from '../tdo-shared/tooth-picker/tooth-picker.component';
import {cfgTooth} from '../tdo-shared/tooth-picker/tooth-picker.models';
import {ToothUiManagerModel} from '../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ToothConfigurationModel} from '../../models/teeth/tooth-configuration.model';
import {StaticDataService} from '../../services/static-data.service';
import {CaseProcedureConfigurationModel} from '../../models/caseProcedures/case-procedure-configuration.model';
import {
  CaseCreateChildProceduresDialogComponent
} from './dialog/case-create-child-procedures-dialog/case-create-child-procedures-dialog.component';


@Component({
  standalone: false,
  selector: 'app-case-create-wizard',
  templateUrl: './case-create-wizard.component.html',
  styleUrls: ['./case-create-wizard.component.scss']
})
export class CaseCreateWizardComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper;
  aProcedures: any;
  selectedProcedure: CaseProcedureConfigurationModel;
  selectedForms: CaseProcedureFormConfigurationModel[] = [];
  formOrderCounter: number;
  caseName: string;
  isBusy: boolean = true;
  messageSubscription: any;
  private destroyed = false;

  stepIndex = 0;
  selectedTeeth: ToothConfigurationModel[] = [];

  constructor(private _caseService: CaseCreateWizardService,
              private globals: Globals,
              private messagingService: MessagingService,
              private staticDataService: StaticDataService,
              private dialog: MatDialog,
              private cdr: ChangeDetectorRef) { }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }

  private safeDetectChanges(): void {
    const viewRef = this.cdr as any;
    if (!this.destroyed && !viewRef?.destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnInit() {
    this.formOrderCounter = 0;
    this.messageSubscription = this.messagingService.componentMessageCall.subscribe(response => {
      if (response.event === MessagingConstants.PATIENT_CHANGED ) {
        this.stepper?.reset();
        this.safeDetectChanges();
      }
    });
    this._caseService.getProcedureGroup('AA000001-0000-0000-0000-000000000002').subscribe(data => {
      this.aProcedures = data || [];
      this.selectedProcedure = this.aProcedures.length > 0 ? this.aProcedures[0] : null;
      this.isBusy = false;
      this.safeDetectChanges();
    }, () => {
      this.aProcedures = [];
      this.selectedProcedure = null;
      this.isBusy = false;
      this.safeDetectChanges();
    });

  }

  clickProcedureSelected(eventProc: any): void {
    const d = new Date();
    const tdoLocale = 'en-US';

    this.stepIndex = this.stepper.selectedIndex;
    // this.stepper.selectedIndex = this.stepIndex;
    this.selectedProcedure = eventProc;
    this.selectedProcedure.isSelected = true;

    const vvi = this.staticDataService.validValueItems.find(p => p.ValidValueItemId === this.selectedProcedure.enumProcedureTypeID);
    if (vvi) {
      this.caseName = vvi.ItemDisplayValue + ':' + d.toLocaleString(tdoLocale, {year: 'numeric', month: 'short', day: 'numeric'});
    } else {
      this.caseName = d.toLocaleString(tdoLocale, {year: 'numeric', month: 'short', day: 'numeric'});
    }
    this.selectedProcedure.cfgCaseProcedureForms = this.selectedProcedure.cfgCaseProcedureForms.sort((a, b) => a.formOrder + a.DFormId < b.formOrder + b.DFormId ? -1 : a.formOrder + a.DFormId > b.formOrder + b.DFormId ? 1 : 0);

    this._caseService.checkIfParentProcedure(this.selectedProcedure.CaseProcedureId).subscribe((res) => {
      if (res && res.length > 0) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = res;
        this.dialog.open(CaseCreateChildProceduresDialogComponent, config).afterClosed().subscribe((procedure) => {
          if (procedure) {
            this.selectedProcedure = procedure;
            this.stepper.next();
            if (this.selectedProcedure.cfgCaseProcedureForms.length === 0) {
              this.stepper.next();
            }
            this.formOrderCounter = 0;
            for (const form of this.selectedProcedure.cfgCaseProcedureForms) {
              if (form.isAddByDefault) {
                form.isSelected = true;
                form.SelectedIndex = this.formOrderCounter + 1;
                this.formOrderCounter++;
              }
            }
          } else {
            this.selectedProcedure = null;
          }
          this.safeDetectChanges();
        });
      } else {
        this.stepper.next();
        this.formOrderCounter = 0;
        for (const form of this.selectedProcedure.cfgCaseProcedureForms) {
          if (form.isAddByDefault) {
            form.isSelected = true;
            form.SelectedIndex = this.formOrderCounter + 1;
            this.formOrderCounter++;
          }
        }
        if (this.selectedProcedure.cfgCaseProcedureForms.length === 0) {
          this.stepper.next();
        }
        this.safeDetectChanges();
      }
    });
  }

  saveCase(): void {
    if (!this.selectedProcedure) {
      return;
    }

    const selectedProcForms: string[] = [];
    let i: number;
    let caseInfo: any;

    this.isBusy = true;

    caseInfo = {
      PatientID: '',
      CaseName: '',
      CaseProcedureId: '',
      Forms : [],
      Teeth: []
    };

    caseInfo.PatientID = this.globals.currentPatientId;
    caseInfo.CaseName = this.caseName ;
    caseInfo.CaseProcedureId = this.selectedProcedure.CaseProcedureId;
    caseInfo.Teeth = this.selectedTeeth.map(p => p.ToothId);

    for (i = 0; i < this.selectedProcedure.cfgCaseProcedureForms.length; i++) {
      if (this.selectedProcedure.cfgCaseProcedureForms[i].SelectedIndex > 0) {
        selectedProcForms.push(this.selectedProcedure.cfgCaseProcedureForms[i].DFormId);
      }
    }
    caseInfo.Forms = selectedProcForms;

    this._caseService.saveCase(caseInfo).subscribe(data => {
      console.log('Case Saved ' + data);

      this.messagingService.broadCastMessage(MessagingConstants.CASES_REFRESH, data.PatientCaseId);

      this.isBusy = false;
      this.safeDetectChanges();
    }, () => {
      this.isBusy = false;
      this.safeDetectChanges();
    });
  }

  clickForm(eventForm: CaseProcedureFormConfigurationModel): void {
    if ( eventForm.isSelected == null)  {
      eventForm.isSelected = true;
    } else {
      eventForm.isSelected = !eventForm.isSelected;
    }

    if (eventForm.isSelected === true) {
      this.formOrderCounter = this.formOrderCounter + 1;
      eventForm.SelectedIndex = this.formOrderCounter;
    }
    else {
      eventForm.SelectedIndex = 0;

      let j: number;
      let i: number;
      j = 0;

      this.formOrderCounter = 0;

      let a: any;
      a = this.selectedProcedure.cfgCaseProcedureForms.sort((a, b) => a.SelectedIndex < b.SelectedIndex ? -1 : a.SelectedIndex > b.SelectedIndex ? 1 : 0);

      for (i = 0; i < this.selectedProcedure.cfgCaseProcedureForms.length; i++) {
        if (this.selectedProcedure.cfgCaseProcedureForms[i].SelectedIndex > 0) {
          this.formOrderCounter = this.formOrderCounter + 1;
          this.selectedProcedure.cfgCaseProcedureForms[i].SelectedIndex = this.formOrderCounter;
        }
      }

      a = this.selectedProcedure.cfgCaseProcedureForms.sort((a, b) => a.formOrder + a.DFormId < b.formOrder + b.DFormId ? -1 : a.formOrder + a.DFormId > b.formOrder + b.DFormId ? 1 : 0);
    }
  }

  onStepperSelectionChange(event: StepperSelectionEvent) {
    this.stepIndex = event.selectedIndex;
  }

  onReset() {
    this.stepper.reset();
    for (const form of this.selectedProcedure?.cfgCaseProcedureForms) {
      form.isSelected = false;
      form.SelectedIndex = 0;
    }
    this.selectedProcedure = this.aProcedures?.length ? this.aProcedures[0] : null;
    this.selectedTeeth = [];
    this.formOrderCounter = 0;
    this.safeDetectChanges();
  }

  getSelectedForms() {
    let selectedForms: CaseProcedureFormConfigurationModel[] = [];
    if (this.selectedProcedure && this.selectedProcedure.cfgCaseProcedureForms) {
      for (const form of this.selectedProcedure.cfgCaseProcedureForms) {
        if (form.isSelected) {
          selectedForms.push(form);
        }
      }
      selectedForms = selectedForms.sort((a, b) => {
        return a.SelectedIndex - b.SelectedIndex;
      });
    }

    return selectedForms;
  }

  openDialogEditTeeth() {
    const dialogRef = this.dialog.open(ToothPickerComponent, {
      panelClass: 'dialog',
      data: {
        isMultiSelect: true,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // array of teeth
      if (result) {
        this.selectedTeeth = [];
        const toothUI: ToothUiManagerModel[] = result;
        toothUI.forEach(a => {
          this.selectedTeeth.push(a.toothModel);
        });
        this.safeDetectChanges();
      }
    });
  }
}


